import actions from '../../../../../FSM/shared/actions'
import guards from '../../../../../FSM/shared/guards'
import { MachineConfigType } from '../../../../../FSM/shared/config'

export const QB_CLOSED = 'closed'

export const buildClosedConfig = (id: string): MachineConfigType => ({
  id,
  initial: QB_CLOSED,
  context: {},
  states: {
    [QB_CLOSED]: {}, // no transitions — page is shown, user navigates via button
  },
})

export const buildClosedOptions = () => ({ actions, guards })
